import PaymentTable from './PaymentTable';
export default PaymentTable;
